import { useCallback } from 'react';

import { useAppDispatch, useDeleteFromLineup } from '@pkg/hooks';
import { type Position } from '@pkg/types/enums';

import { type CollectionChainType, type Competition } from '@app/client';
import { addNotification } from '@app/store/actions/notification';
import { useFantasyLineupStore, useFantasyMetadataStore } from '@app/store/zustand';
import { useFantasyAutopickedStore } from '@app/store/zustand/FantasyGame/Autopicked';

export type AddToLineupOptions = {
    isUpdate?: boolean;
    isConfirmed?: boolean;
    isAutoPicked?: boolean;
    submitOnAdd?: boolean;
    pessimistic?: boolean;
    callback?: () => void;
    onError?: () => void;
    customGame?: Competition;
};
export type CollectionEntryType = {
    quantity: number;
    collectionSlug: string;
    collectionName?: string;
    chain: CollectionChainType;
    position?: Position;
};
type RemoveFromLineupProps = {
    slug: string;
    onSuccess?: () => void;
    onError?: () => void;
    skipStoreUpdate?: boolean;
    chain: CollectionChainType;
};

// TODO - rename to be remove specific?
export const useFantasyLineupItems = () => {
    const { removeLineupItem } = useFantasyLineupStore();
    const { currentGame, currentGameWishlistId } = useFantasyMetadataStore();
    const { mutateAsync: deleteFromWishlist } = useDeleteFromLineup({
        invalidateOnSuccess: true,
    });

    const { removeAutopickedItem } = useFantasyAutopickedStore();

    const dispatch = useAppDispatch();

    const removeFromLineup = useCallback(
        ({ slug, skipStoreUpdate, onSuccess, onError, chain }: RemoveFromLineupProps) => {
            if (currentGameWishlistId) {
                if (!skipStoreUpdate) {
                    removeLineupItem({ slug });
                }
                removeAutopickedItem({ fw_slug: currentGameWishlistId, slug });
                deleteFromWishlist({
                    wishlistId: currentGameWishlistId,
                    slug,
                    competitionId: currentGame?.id,
                    network: chain,
                }).then((r) => {
                    if (!r.ok && r.error) {
                        dispatch(
                            addNotification({
                                message: 'Error removing lineup item',
                                // message: r.error ?? 'Error removing lineup item',
                                severity: 'error',
                            }),
                        );
                        onError?.();
                        return;
                    }
                    onSuccess?.();
                });
            }
        },
        [currentGameWishlistId, removeLineupItem, removeAutopickedItem, deleteFromWishlist, currentGame?.id, dispatch],
    );

    return {
        removeFromLineup,
    };
};
